<template>
    <div class="video-controls" @mouseenter="isActive = true" @mouseleave="isActive = false">
        <div :class="['video-controls__overlay', {'video-controls__overlay--visible': isActive}]">
            <div class="video-controls__progress" v-if="!isLiveStream">
                <vue-slider v-model="currentTime" :max="roundedVideoLength" :duration="1" tooltip="none" class="video-controls__timeline" @change="handleVideoProgress"></vue-slider>
            </div>
            <div class="video-controls__controls">
                <div class="video-controls__controls--left">
                    <button
                        id="videoControls_play"
                        :title="videoPlaying ? 'Pause' : 'Play'"
                        type="button"
                        class="video-controls__button video-controls__button--play"
                        @click="handleVideoPlay"
                    >
                        <icon :icon="videoPlaying ? 'pause' : 'play'" :height="14" :width="14"/>
                    </button>
                    <span v-if="!isLiveStream">{{ playTime | timeFormat }} / {{ roundedVideoLength | timeFormat }}</span>
                </div>
                <div class="video-controls__controls--right">
                    <v-tooltip top v-if="hasSubtitles">
                        <template v-slot:activator="{ on }">
                            <button v-on="on" id="videoControls_subtitle" @click="handleAssVisibility" title="Download Video"
                                    type="button" class="video-controls__button">
                                <icon icon="subtitles" :height="14" :width="14" />
                            </button>
                        </template>
                        <span>Toggle Subtitles</span>
                    </v-tooltip>

                    <v-tooltip top v-if="!isLiveStream && canDownloadVideo">
                        <template v-slot:activator="{ on }">
                            <button v-on="on" id="videoControls_download" @click="handleVideoDownload" title="Download Video"
                                    type="button" class="video-controls__button">
                                <icon icon="download" :height="14" :width="14" />
                            </button>
                        </template>
                        <span>Download Video</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <button v-on="on" id="videoControls_fullscreen" @click="handleFullscreen"
                                    title="Full Screen" type="button" class="video-controls__button">
                                <icon :icon="isFullScreen ? 'fullscreen-exit' : 'fullscreen'" :height="14" :width="14" />
                            </button>
                        </template>
                        <span>Toggle Fullscreen</span>
                    </v-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/atoms/Icon'
import VueSlider from 'vue-slider-component'

export default {
    name: 'VideoControls',
    components: {
        Icon,
        VueSlider
    },
    props: {
        isLiveStream: {
            type: Boolean,
            required: false,
            default: false
        },
        videoPlaying: {
            type: Boolean,
            required: true
        },
        playTime: {
            type: Number,
            required: true
        },
        isFullScreen: {
            type: Boolean,
            required: true
        },
        hasSubtitles: {
            type: Boolean,
            required: false,
            default: false
        },
        canDownloadVideo: {
            type: Boolean,
            required: false,
            default: true
        },
        videoLength: {
            type: Number,
            required: true
        },
        handleFullscreen: {
            type: Function,
            required: true
        },
        handleVideoDownload: {
            type: Function,
            required: true
        },
        handleVideoProgress: {
            type: Function,
            required: true
        },
        handleVideoPlay: {
            type: Function,
            required: true
        },
        handleAssVisibility: {
            type: [Function, null],
            required: false,
            default: null
        }
    },
    data () {
        return {
            isActive: false
        }
    },
    filters: {
        timeFormat (s) {
            let seconds = s;
            const videoLength = (seconds - (seconds %= 60)) / 60 + (seconds > 9 ? ':' : ':0') + seconds;
            return videoLength
        }
    },
    computed: {
        currentTime: {
            get () {
                return this.playTime
            },
            set (value) {
                this.handleVideoProgress(value)
            }
        },
        roundedVideoLength () {
            return Math.ceil(this.videoLength)
        }
    },
    mounted () {
    },
    methods: {}
}
</script>

<style scoped lang="scss">
.video-controls {
    $c: &;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    color: $white;

    &__button {
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        outline: none;

        &--play {
            margin-right: 10px;
        }
    }

    &__overlay {
        opacity: 0.25;
        transition: opacity 0.2s ease, background 0.2s ease;
        padding: 0 10px 10px;

        &--visible {
            opacity: 1;
            background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%);
        }
    }

    &__progress {
        width: 100%;

        &-container {
            display: flex;
            width: 100%;
            height: 5px;
            margin-bottom: 1rem;
            background-color: rgba($inactive, 0.5);
            cursor: pointer;
        }

        &-bar {
            width:0%;
            flex:0;
            flex-basis:0%;
            background-color: $secondary;
        }
    }

    &__controls {
        display: flex;
        font-size: 14px;

        &--left, &--right {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &--right {
            margin-left: auto;

            #{$c}__button {
                margin-left: 10px;
            }
        }
    }

    &__timeline {
        ::v-deep .vue-slider-dot {
            transition-timing-function: linear !important;
        }
        ::v-deep .vue-slider-process {
            transition-timing-function: linear;
        }
    }
}
</style>
